/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RawDataPointGpsModel
 */
export interface RawDataPointGpsModel {
    /**
     * 
     * @type {string}
     * @memberof RawDataPointGpsModel
     */
    type: RawDataPointGpsModelTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof RawDataPointGpsModel
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof RawDataPointGpsModel
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof RawDataPointGpsModel
     */
    lon: number;
    /**
     * 
     * @type {number}
     * @memberof RawDataPointGpsModel
     */
    alt?: number;
    /**
     * 
     * @type {number}
     * @memberof RawDataPointGpsModel
     */
    speed: number;
}

export function RawDataPointGpsModelFromJSON(json: any): RawDataPointGpsModel {
    return RawDataPointGpsModelFromJSONTyped(json, false);
}

export function RawDataPointGpsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawDataPointGpsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'time': (new Date(json['time'])),
        'lat': json['lat'],
        'lon': json['lon'],
        'alt': !exists(json, 'alt') ? undefined : json['alt'],
        'speed': json['speed'],
    };
}

export function RawDataPointGpsModelToJSON(value?: RawDataPointGpsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'time': (value.time.toISOString()),
        'lat': value.lat,
        'lon': value.lon,
        'alt': value.alt,
        'speed': value.speed,
    };
}

/**
* @export
* @enum {string}
*/
export enum RawDataPointGpsModelTypeEnum {
    Gps = 'gps'
}


